export default __webpack_public_path__ + "static/balances-page-faded-48cf5667862750baa500dd72490ca060.png";